<template>
  <v-checkbox
          :label="name"
          :hint="description"
          persistent-hint
          :value="currentValue" @change="onInput"
  />
</template>

<script>

import formComponent from '../mixins/form_component'
import defaultParser from '../parsers/checkbox_parser'

export default {

  name: 'FormCheckbox',

  mixins: [ formComponent ],

  /**
   *
   *
   */
  props: {

  },

  /**
   *
   *
   */
  data() {

    return {

      // Описание поля
      description: ''
    }
  },

  /**
   *
   *
   */
  watch: {

  },

  /**
   *
   *
   */
  computed: {

  },

  /**
   *
   *
   */
  methods: {

    /**
     * Инициализация компонента.
     *
     *  - подключение парсера
     *  - инициализация данных и значения по умолчанию
     *
     */
    init() {

      // Инициализация парсера.
      this.initParser( defaultParser )

      this.name = this.parser.getName( this.data )
      this.description = this.parser.getDescription( this.data )
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/apps/bpm/components/form/FormCheckbox.vue